import React from 'react';
import classnames from 'classnames';
import '../methodologyContainer.style.scss';

export const NameContainer = ({ isOutOfContext, name }: { isOutOfContext?: boolean; name: string | JSX.Element }) => {
  const customStyles = classnames('component-name', {
    'not-in-context': isOutOfContext
  });

  return (
    <div id='characteristic-and-indicators-name-container' className={customStyles}>
      {name}
    </div>
  );
};
